import { render, staticRenderFns } from "./postFast.vue?vue&type=template&id=48bbd978"
import script from "./postFast.vue?vue&type=script&lang=js"
export * from "./postFast.vue?vue&type=script&lang=js"
import style0 from "./postFast.vue?vue&type=style&index=0&id=48bbd978&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports